// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"h2","heroImageWrapper":"h3","gradientLeft":"h4","gradientBottom":"h5","brandLogo":"h6"};